import empowerHistoryList from '@/views/empower/empowerHistoryList';

export default [{
    path: 'empower',
    redirect: 'empower/empowerHistoryList'
}, {
    path: 'empower/empowerHistoryList',
    component: empowerHistoryList,
}];



// WEBPACK FOOTER //
// ./src/router/modules/miscRoutes.js